import { getAllNotifications, disableNotification, makeReadNotifications, getAllNotificationsByUser } from '@/services/notification';

export default {
  getAllNotifications: async ({ commit }) => {
    try {
      const { data } = await getAllNotifications();

      commit('setAllNotifications', data);
    } catch (err) {
      console.error(err);
    }
  },

  showNotification: ({ commit }, payload) => commit('showNotification', payload),

  closeNotification: ({ commit }) => commit('closeNotification'),

  disableNotification: async ({ commit }, payload) => {
    try {
      const { status } = await disableNotification(payload.id);

      status === 204 && commit('disableNotification', payload);
    } catch (err) {
      console.error(err);
    }
  },

  makeReadNotifications: async ({ commit }, payload) => {
    try {
      await makeReadNotifications(payload.ids);

      commit('makeReadNotifications', payload);
    } catch (err) {
      console.error(err);
    }
  },

  getAllNotificationsByUser: async ({ commit }) => {
    try {
      const { data } = await getAllNotificationsByUser();

      commit('setAllNotificationsByUser', data);
    } catch (err) {
      console.error(err);
    }
  }
};
